import { jsx as n } from "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as p } from "../../../../context/theme/hooks.js";
import "../../../layout/Stack/Stack.js";
import a from "../../../layout/Box/Box.js";
import "react";
import "../../../../index-CZ8zjHGv.js";
import "../../../layout/Center/Center.js";
import "../../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../../layout/Columns/ColumnsContext.js";
function C({ position: o, color: e }) {
  const t = s(o, e);
  return t && /* @__PURE__ */ n(
    a,
    {
      zIndex: 2,
      width: "0px",
      height: "0px",
      position: "absolute",
      borderStyle: "solid",
      borderWidth: "large",
      ...t
    }
  );
}
function s(o, e) {
  const t = p(), r = e || t.foreground;
  switch (o) {
    case "left":
      return {
        right: "-8px",
        borderRightWidth: "none",
        borderColor: `transparent transparent  transparent ${r}`
      };
    case "right":
      return {
        borderLeftWidth: "none",
        left: "-8px",
        borderColor: `transparent ${r}  transparent transparent`
      };
    case "top":
      return {
        bottom: "-8px",
        left: "calc(50% - 8px)",
        borderBottomWidth: "none",
        borderColor: `${r} transparent transparent transparent `
      };
    case "bottom":
      return {
        top: "-8px",
        left: "calc(50% - 8px)",
        borderTopWidth: "none",
        borderColor: `transparent transparent ${r} transparent `
      };
    case "bottomRight":
      return {
        left: "0",
        top: "-8px",
        borderTopWidth: "none",
        borderColor: `transparent transparent ${r} transparent `
      };
    case "topRight":
      return {
        left: "0",
        bottom: "-8px",
        borderBottomWidth: "none",
        borderColor: `${r} transparent transparent transparent `
      };
    case "bottomLeft":
      return {
        top: "-8px",
        right: "0",
        borderTopWidth: "none",
        borderColor: `transparent transparent ${r} transparent `
      };
    case "topLeft":
      return {
        right: "0",
        bottom: "-8px",
        borderBottomWidth: "none",
        borderColor: `${r} transparent transparent transparent `
      };
    default:
      return null;
  }
}
export {
  C as default
};
